// @ts-nocheck

import HomeOutlined from '@ant-design/icons/HomeOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined'

export default {
  HomeOutlined,
SettingOutlined
}
    